import React from "react";
import { Route, Redirect } from "react-router-dom";
import { getStorage } from "./storage";

export const checkEmailExistInStorage = () => {
  const storage = getStorage();
  return storage.userName;
};

function PrivateRoute({ component: Component, ...rest }) {
  let { isAuthenticated } = rest;

  if (!isAuthenticated) {
    isAuthenticated = checkEmailExistInStorage();
  }

  return (
    <Route
      {...rest}
      render={(props) =>
        isAuthenticated ? (
          <Component {...props} />
        ) : (
          <Redirect
            to={{
              pathname: "/signin",
              // state: { from: props.location },
            }}
          />
        )
      }
    />
  );
}

export default PrivateRoute;
